import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/about-banner.jpg';
import aboutprofile from '../assests/img/about-por.jpg';


import 'photoswipe/dist/photoswipe.css'

import { Gallery, Item } from 'react-photoswipe-gallery'



function Media() {
return (
    <div >
    
    <Header/>
    {/* <Showlist/> */}
    
    <div className='container'>
        <div className='about-banner'>
            <img src={aboutBanner} alt=""/>
        </div>
    </div>
    
    <div className='container main-contant'>
      <div className='inner-page-container'>
        <h1 className='page-title'>Media</h1>     

         <Gallery>
    <Item 
      className="gallery-item"
      original="https://aije.in/wp-content/uploads/photo-gallery/A-94.jpg?bwg=1681325175"
      thumbnail="https://aije.in/wp-content/uploads/photo-gallery/thumb/A-94.jpg?bwg=1681325175"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="https://aije.in/wp-content/uploads/photo-gallery/thumb/A-94.jpg?bwg=1681325175" />
      )}
    </Item>
    <Item
      className="gallery-item"
      original="https://aije.in/wp-content/uploads/photo-gallery/A-92.jpg?bwg=1681325175"
      thumbnail="https://aije.in/wp-content/uploads/photo-gallery/thumb/A-92.jpg?bwg=1681325175"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="https://aije.in/wp-content/uploads/photo-gallery/thumb/A-92.jpg?bwg=1681325175" />
      )}
    </Item>
    <Item
      className="gallery-item"
      original="https://aije.in/wp-content/uploads/photo-gallery/A-89.jpg?bwg=1681325175"
      thumbnail="https://aije.in/wp-content/uploads/photo-gallery/thumb/A-89.jpg?bwg=1681325175"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="https://aije.in/wp-content/uploads/photo-gallery/thumb/A-89.jpg?bwg=1681325175" />
      )}
    </Item>
    <Item
      className="gallery-item"
      original="https://aije.in/wp-content/uploads/photo-gallery/A-86.jpg?bwg=1681325175"
      thumbnail="https://aije.in/wp-content/uploads/photo-gallery/thumb/A-86.jpg?bwg=1681325175"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="https://aije.in/wp-content/uploads/photo-gallery/thumb/A-86.jpg?bwg=1681325175" />
      )}
    </Item>
  </Gallery> 
      </div>
    
    </div>
    <Footer/>
     </div>
    )
}

export default  Media;
